import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

import { MoralisProvider } from "react-moralis";
import { ToastContainer } from "react-toastify";

import "./styles/index.css";
import { BrowserRouter } from "react-router-dom";
import HooksProvider from "./hooks/HooksProvider";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MoralisProvider
        appId="mUTY2bpmEhqopYfQuUcMRDn6uSXwlLfj1cY4k5xD"
        serverUrl="https://drpsk1phyzel.moralishost.com:2053/server"
      >
        <HooksProvider>
          <App />
          <ToastContainer limit="1" />
        </HooksProvider>
      </MoralisProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
